// bao migrate skip
import TabPage from "./../factories/tab-page";
import "./../factories/tab-controller";
import "./../bindings/bao-date-time-box";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-tabs";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import SubscriptionViewModel from "./../factories/subscription-view-model";
import baoRouter from "./../services/bao-router";
import BaoDialog from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import finitoService from "./../services/finito-service";
import TabController from "./../factories/tab-controller";
import * as moment from "moment";
import appTabController from "../services/app-tab-controller";
import AdvancedPrintingDialog from "./dialogs/advanced-printing-dialog";

class ShiftReportViewModel extends SubscriptionViewModel {
    ReportId: KnockoutObservable<string>;
    ShiftbookId: KnockoutObservable<string> = ko.observable(null);;
    ShiftGroupId: KnockoutObservable<string>;
    FormName: KnockoutObservable<string>;
    IsOriginal: KnockoutObservable<boolean> = ko.observable(false);
    /**
     * if set to true it will filter the data to get the data when
     * report is closed if it configured in the transfer definition
     * */
    IsShiftClosure: KnockoutObservable<boolean> = ko.observable(false);
    IsClosed: KnockoutObservable<boolean> = ko.observable();
    IsValid: KnockoutObservable<boolean>;
    ReportShortTitle: KnockoutObservable<string>;
    ReportTitle: KnockoutObservable<string>;
    TabViewModel = new TabController(false);
    ShiftGroups = ko.observableArray();
    Shiftbooks: KnockoutObservable<any> = ko.observable([]);
    IsFavorite: KnockoutObservable<boolean> = ko.observable(false);
    Color: string = "text-primary";
    Icon: string = "fal fa-book";
    Sort: number = 120;
    PermissionPrefix = null;
    CurrentRevision = ko.observable(true);
    IsRead = ko.observable<boolean>(false);
    ShiftStartTime = ko.observable("");
    ValidDateJs = ko.observable();
    ShowReportReadBy = ko.observable<boolean>(false);
    ShowReportShiftGroup = ko.observable<boolean>(true);
    TabModels = ko.observableArray([]);
    Permissions = ko.observable({});
    HasShowReadersPermission = ko.observable<boolean>(false);
    ShowAllReadByEntries = ko.observable<boolean>();
    SelectedTabId = ko.observable('');
    NotLoadedTabsUrls: NotLoadedTabsUrls[] = [];
    /**
    * if set to true report is read by current user
    * */
    IsReadByUser: KnockoutObservable<boolean> = ko.observable(false);

    IsAutomaticReadWorkflowEnabled: KnockoutObservable<boolean> = ko.observable();

    constructor(tabPage) {
        super(tabPage);
        this.SettingsKeyPermission("ShiftbookSave");
        this.SettingsKeyPermissionApplicationId(window.FinitoApplicationId);
        this.TabModels.subscribe((newValue) => {
            this.TabViewModel.Tabs([]);
            var infoId = baoRouter.getRouteValue('infoid', tabPage);
            $.each(ko.toJS(newValue), (index, item) => {
                var newTab = new TabPage(null, item.Title);
                newTab.Url(item.Url);
                newTab.UrlData({
                    reportId: this.ReportId()
                });
                newTab.IsClosable(false);
                if (item.Url === "CheckwareTab") {
                    newTab.PreLoad(true);
                }
                else {
                    newTab.PreLoad(item.PreLoad);
                }

                newTab.Visible(item.Visible);
                newTab.ObjectId(item.TabId);
                newTab.AutoSelect = Boolean((item.Url === "Information" && infoId !== null) || (infoId === null && index == 0));
                this.NotLoadedTabsUrls.push({ TabId: item.TabId, CompleteCheckUrl: item.CompleteCheckUrl });
                this.TabViewModel.AddTab(newTab);
            });
            const tabs = this.TabViewModel.Tabs();
            if (tabs.length !== 0 && this.SelectedTabId().length !== 0) {
                var selectTab = tabs.filter(x => x.ObjectId() == this.SelectedTabId());
                if (selectTab.length !== 0) {
                    this.TabViewModel.SelectTab(selectTab[0]);
                }
            }
            this.SelectedTabId('');
        });
        this.Permissions.subscribe((newValue) => {
            this.SetPermissions(newValue);
        });
        this.ShiftbookId.subscribe((id) => {
            this.SettingsUrl(id ? 'Shiftbook/' + id : null);
        });
        this.HasShowReadersPermission.subscribe(() => {
            this.GetReadAllState();
        });
        this.IsAutomaticReadWorkflowEnabled.subscribe(() => {
            if (this.IsAutomaticReadWorkflowEnabled() && !this.IsReadByUser() && this.IsClosed()) {
                this.markRead();
            }
        });
        this.IsClosed.subscribe(() => {
            if (this.IsAutomaticReadWorkflowEnabled() && !this.IsReadByUser() && this.IsClosed()) {
                this.markRead();
            }
        });
    }
    init() {
        this.TabPage.IsLoading(true);
        return $.when(this.LoadShiftReports()).then(() => {
            return this.getReport();
        });
    }
    ;
    LoadShiftReports(): any {
        return Bao.post("Dialog/GetShiftBooksForLinkedTasks", JSON.stringify({ instructionType: "ShiftBook" })).
            then((serverResult) => {
                this.Shiftbooks([]);
                if (serverResult != null) {
                    this.Shiftbooks(serverResult.TaskBooksForCurrentUser);
                }
            });
    }
    loaded() {
        var def = $.Deferred();
        this.TabPage.IsLoading(false);
        Bao.bindEvent('FavoriteIcon:refresh', (value) => {
            this.IsFavorite(!this.IsFavorite());
        });
        this.subscribe(this.ShiftGroupId, (shiftGroupId) => {
            this.saveShiftGroup(shiftGroupId);
        });
        this.subscribe(this.ShiftbookId, (shiftbookId) => {
            this.loadNewShiftreport(shiftbookId);
        });
        this.PermissionPrefix = 'action' + this.FormName();
        this.registerMenuClick();
        this.toggleButtons();
        this.isQuickStartModuleActive();
        def.resolve();
        return def.promise();
    }
    ;
    BeforeClose(fn) {
        this.canClose()
            .then((canCloseTab) => {
                if (canCloseTab) {
                    this.disposeTabs();
                    return fn();
                }
            }).always(() => {
                this.TabPage.IsLoading(false);
            });
    }
    ;
    // Dirty-Check der Tabs incl. Validierung und Save
    canClose(closeReport?) {
        this.TabPage.IsLoading(true);
        var tabs = this.TabViewModel.Tabs();
        if (<any>tabs == false || tabs.length == 0) {
            return $.Deferred<boolean>().resolve(true).promise();
        }
        return this.CompletedCheckwareForNotLoadedTabs(tabs, closeReport)
            .then((result: boolean) => {
                if (!result) {
                    return $.Deferred<boolean>().resolve(false).promise();
                }

                return this.CompletedMandatoryFieldsForNotLoadedTabs(tabs, closeReport)
                    .then((resultCompletedMandatoryFields: boolean) => {
                        var result = $.Deferred<boolean>();
                        if (!resultCompletedMandatoryFields) {
                            this.TabPage.IsLoading(false);
                            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.CheckRequiredFields), 'info');
                            return result.resolve(false).promise();
                        }
                        //
                        // DirtyCheck- und Save-Funktionen der Tabs sammeln
                        var tabValidationMethods = ko.utils.arrayMap(ko.utils.arrayFilter(tabs, (tab: any) => {
                            return tab.ViewModel()
                                && $.isFunction(tab.ViewModel().canClose)
                                && $.isFunction(tab.ViewModel().CompleteCheck)
                                && $.isFunction(tab.ViewModel().Save);
                        }), (tab: any) => {
                            return {
                                thisContext: tab.ViewModel(),
                                canClose: tab.ViewModel().canClose,
                                validate: tab.ViewModel().CompleteCheck,
                                save: tab.ViewModel().Save
                            };
                        });
                        //
                        // Tabs auf Änderungen prüfen
                        if (!(tabValidationMethods.length > 0)) {
                            return result.resolve(true).promise();
                        }
                        $.when.apply($, tabValidationMethods.map((methods) => {
                            this.TabPage.IsLoading(false);
                            return methods.canClose.call(methods.thisContext);
                        })).then((...myArguments) => {
                            this.TabPage.IsLoading(true);
                            var canCloseResults = this.getArgumentsArray(myArguments);
                            //
                            // Tabs validieren (CompleteCheck)
                            $.when.apply($, tabValidationMethods.map((m) => {
                                this.TabPage.IsLoading(false);
                                return m.validate.call(m.thisContext, closeReport);
                            })).then((...myArguments) => {
                                this.TabPage.IsLoading(true);
                                var validationResults = this.getArgumentsArray(myArguments);
                                if (closeReport == true) {
                                    this.TabPage.IsLoading(false);
                                    // should close dialog
                                    var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.ConfirmIsReportClosed), 'yesno');
                                    dialog.DialogResult.subscribe((canClose) => {
                                        this.TabPage.IsLoading(true);
                                        if (canClose) {
                                            // will handle the scenario where manual completion is not checked in the tab type checkware
                                            let shiftReportCheckwareTabs = tabValidationMethods.filter((tab: any) => tab.thisContext?.ChecklistModel !== undefined);

                                            shiftReportCheckwareTabs?.forEach((tab, index) => {
                                                if (tab !== undefined) {
                                                    let checkwareTabIndex = tabValidationMethods.indexOf(tab);
                                                    if (validationResults[checkwareTabIndex]) {
                                                        if (!tab.thisContext?.ChecklistModel?.CompleteCheck()) {
                                                            validationResults[checkwareTabIndex] = false;
                                                        }
                                                    }
                                                }
                                            })
                                            this.shouldSaveExecute.call(this, true, validationResults, result, tabValidationMethods);
                                        }
                                        else {
                                            result.resolve(false);
                                        }
                                    });
                                }
                                else {
                                    var isDirty = false;
                                    ko.utils.arrayForEach(canCloseResults, (canCloseTab) => {
                                        if (!isDirty) {
                                            isDirty = !canCloseTab;
                                        }
                                    });
                                    if (isDirty) {
                                        this.shouldSave().then((shouldSave) => {
                                            this.shouldSaveExecute.call(this, shouldSave, validationResults, result, tabValidationMethods);
                                        });
                                    }
                                    else {
                                        result.resolve(true);
                                    }
                                }
                            });
                        });
                        return result.promise();
                    });
            }).always(() => {
                this.TabPage.IsLoading(false);
            });
    }
    ;
    /*
     * A function that checks if there are not loaded tabs with mandatory fields that are not completed. If everything is complete it returns true.
     * */
    private CompletedMandatoryFieldsForNotLoadedTabs(tabs: TabPage[], closeReport?): JQueryPromise<boolean> {
        var result = $.Deferred<boolean>();
        if (!closeReport) {
            return result.resolve(true).promise();
        }
        const notLoadedTabs: NotLoadedTabsUrls[] = this.GetNotLoadedTabs(tabs);
        if (notLoadedTabs.length === 0) {
            return result.resolve(true).promise();
        }
        //
        // Check CompletedMandatoryFields
        $.when.apply($, notLoadedTabs.map((tab) => this.CallEndpointForNotLoadedTab(tab.CompleteCheckUrl, tab.TabId)))
            .then((...myArguments) => {
                var completedMandatoryFieldsResults = this.getArgumentsArray(myArguments);
                if (completedMandatoryFieldsResults.indexOf(false) === -1) {
                    result.resolve(true);
                }
                else {
                    result.resolve(false);
                }
            });
        return result.promise();
    }

    private CompletedCheckwareForNotLoadedTabs(tabs: TabPage[], closeReport?): JQueryPromise<boolean> {
        var result = $.Deferred<boolean>();
        if (!closeReport) {
            return result.resolve(true).promise();
        }
        const notLoadedTabs: NotLoadedTabsUrls[] = this.GetNotLoadedTabs(tabs);
        if (notLoadedTabs.length === 0) {
            return result.resolve(true).promise();
        }
        //
        // Check CompletedMandatoryFields
        $.when.apply($, notLoadedTabs.map((tab) => this.CallEndpointForNotLoadedTab(tab.CompleteCheckUrl, tab.TabId)))
            .then((...myArguments) => {
                let resultMessage = "";
                let resultValue = true;
                var completedMandatoryFieldsResults: any[] = this.getArgumentsArray(myArguments);

                if (completedMandatoryFieldsResults) {
                    completedMandatoryFieldsResults.forEach((item) => {
                        if (item.Result === false && Boolean(item.Message)) {
                            resultMessage = resultMessage + item.Message + '<br />';
                            resultValue = false;
                        }
                    });
                }
                if (!resultValue) {
                    new BaoDialog(Bao.Session.ApplicationName, resultMessage, 'info');
                }
                result.resolve(resultValue);

            });
        return result.promise();
    }

    /*
     * Returns tab arrays that have not been loaded / reloaded
     * */
    private GetNotLoadedTabs(tabs: TabPage[]): NotLoadedTabsUrls[] {
        let result: NotLoadedTabsUrls[] = [];
        tabs.forEach(tab => {
            if (tab.ViewModel()) {
                return;
            }
            result.push(this.NotLoadedTabsUrls.filter(item => item.TabId == tab.ObjectId())[0]);
        });
        return result;
    }
    /*
     * Helper function to call endpoints for tabs that have url set
     * */
    private CallEndpointForNotLoadedTab(url: string, shiftbookTabId: string) {
        if (!url) {
            return $.Deferred<boolean>().resolve(true).promise;
        }
        return Bao.post(url, JSON.stringify({ reportId: this.ReportId(), shiftbookTabId: shiftbookTabId }));
    }
    /**
     * @param result
     * @param validationResults
     */
    shouldSaveExecute(shouldSave, validationResults: Array<boolean | Promise<boolean>>, result: JQueryDeferred<boolean>, validationAndSaveMethods: {
        thisContext(): any;
        save(): any;
    }[]) {
        if (shouldSave === true) {
            //Start shouldSave == true                                          
            $.when(...validationResults)
                .then((...valResults) => {
                    //let validationFailed = false;
                    return (<Array<boolean>>valResults).some((r) => {
                        return (r === false);
                    });
                    //return validationFailed;
                })
                .then((validationFailed) => {
                    if (validationFailed == true) {
                        this.TabPage.IsLoading(false);
                        new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msqShiftReportNotComplete"), 'info');
                        result.resolve(false);
                    }
                    else {
                        //
                        // Save-Methods sammeln
                        var saveMethods = [];
                        var index = 0;
                        validationResults.forEach((isValid) => {
                            if (isValid) {
                                saveMethods.push({
                                    thisContext: validationAndSaveMethods[index].thisContext,
                                    save: validationAndSaveMethods[index].save
                                });
                            }
                            index++;
                        });
                        //
                        // Tabs speichern
                        if (saveMethods.length > 0) {
                            $.when.apply($, ko.utils.arrayMap(saveMethods, (m) => {
                                return m.save.call(m.thisContext);
                            })).done((...myArguments) => {
                                var saveResults = this.getArgumentsArray(myArguments);
                                ko.utils.arrayForEach(saveMethods, (m) => {
                                    m.thisContext.TabPage.IsLoading(false);
                                });
                                var saveFailed = ko.utils.arrayFirst(saveResults, (saveResult) => {
                                    return !saveResult;
                                });
                                if (saveFailed) {
                                    result.resolve(false);
                                }
                                else {
                                    result.resolve(true);
                                }
                            });
                        }
                        else {
                            result.resolve(true);
                        }
                    }
                    ///Ende shouldSave == true
                });
            //    
        }
        else if (shouldSave === false) {
            result.resolve(true);
        }
        else {
            result.resolve(false); //abgebrochen
        }
        ;
    }
    ;
    //
    // arguments in Result-Array umwandeln
    getArgumentsArray(args): Array<any> {
        for (var i in args) {
            if (typeof args[i] === "undefined" || args[i] === true || args[i] === false) {
                continue;
            }
            if (args[i][1] === 'success') {
                args[i] = args[i][0];
            }
        }
        if (args[1] === 'success') {
            return [args[0]];
        }
        else {
            return args;
        }
    }
    ;
    //
    // Wollen Sie die Änderungen am Schichtbericht speichern?
    shouldSave() {
        var deferred = $.Deferred();
        var isLoading = this.TabPage.IsLoading();
        this.TabPage.IsLoading(false);
        var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgShiftReportSave"), 'question');
        dialog.DialogResult.subscribe((shouldSave) => {
            var activeInfoTab = this.TabViewModel.SearchTabByObjectId('ActiveInfo');
            if (activeInfoTab && activeInfoTab.IsDirty && shouldSave === true) {
                this.validateDate().then(res => {
                    if (res.Value === true) {
                        this.TabPage.IsLoading(isLoading);
                        deferred.resolve(shouldSave);
                    } else {
                        new BaoDialog(Bao.Session.ApplicationName, res.Message, "info");
                        deferred.resolve()
                    }
                })
            } else {
                deferred.resolve(shouldSave);
            }
        });
        return deferred.promise();
    }
    ;

    //
    // Menü-ClickHandler
    registerMenuClick() {
        BaoMenu.registerEvent((btn) => {
            if (this.TabPage != null && this.TabPage.IsActiveTab != null && this.TabPage.IsActiveTab() === true) {
                switch (btn.ActionKey().substr(this.PermissionPrefix.length)) {
                    case 'Previous':
                        this.previous();
                        break;
                    case 'Calendar':
                        this.calendar();
                        break;
                    case 'Next':
                        this.next();
                        break;
                    case 'Refresh':
                        this.refresh();
                        break;
                    case 'Close':
                        this.close();
                        break;
                    case 'Original':
                        this.original();
                        break;
                    case 'Revision':
                        this.revision();
                        break;
                    case 'Print':
                        this.print();
                        break;
                    case 'MarkRead':
                        this.markRead();
                        break;
                    case 'UnMarkRead':
                        this.unMarkRead();
                        break;
                    case 'AdvancedPrinting':
                        this.openAdvancedPrintingDialog();
                        break;
                    case 'ShiftClosure':
                        this.ShiftClosure();
                        break;
                }
            }
        });
    }

    CompleteCheck() {
        var isComplete = true;
        var def = $.Deferred();
        var completeCheckDefArray = [];
        ko.utils.arrayForEach(this.TabViewModel.Tabs(), (tab: any) => {
            if (tab.Loaded() == true && tab.ViewModel() != null && typeof tab.ViewModel().CompleteCheck == "function") {
                completeCheckDefArray[completeCheckDefArray.length] = tab.ViewModel().CompleteCheck();
            }
        });
        $.when.apply($, completeCheckDefArray).then((...myArguments) => {
            //Durch ergebnisse durchloopen
            var tabCompleteCheckResult = true;
            $.each(myArguments, (index, item) => {
                if (item == false) {
                    tabCompleteCheckResult = false;
                    return false; //each abbrechen
                }
            });
            if (!tabCompleteCheckResult) {
                new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msqShiftReportNotComplete"), "info");
            }
            def.resolve(tabCompleteCheckResult);
        });
        return def.promise();
    }

    // Dispose der Models
    disposeTabs() {
        if (this.TabViewModel && this.TabViewModel.Tabs().length > 0) {
            ko.utils.arrayForEach(this.TabViewModel.Tabs(), (tab: any) => {
                if (ko.isObservable(tab.ViewModel)) {
                    var tabViewModel = tab.ViewModel();
                    if (tabViewModel) {
                        tabViewModel.dispose();
                    }
                }
            });
        }
    }

    // Fetch Report
    getReport(selectTab?: boolean) {
        this.TabPage.IsLoading(true);
        this.disposeTabs();
        return Bao.post('ShiftReport/GetReport', JSON.stringify({
            id: this.TabPage.ObjectId()
        })).then((result) => {
            this.SelectedTabId(selectTab ? this.TabViewModel.SelectedTab().ObjectId() : '');
            ko.map.fromJS(result.Model, this);
            ko.map.fromJS(result.TabModels, this.TabModels);
            ko.map.fromJS(result.ShiftGroups, this.ShiftGroups);
            ko.map.fromJS(result.Permissions, this.Permissions);
            this.TabPage.Title(this.ReportShortTitle());
            (<any>this.TabPage).ToolTip(this.ReportTitle());
        }).always(() => {
            this.TabPage.IsLoading(false);
        });
    }

    // Toolbar-ClickHandler
    toggleButtons() {
        if (this.IsClosed()) {
            BaoMenu.permissionEnable({ ActionKey: this.PermissionPrefix + 'Close', Enabled: false, Context: this.TabPage.Context() });
            if (this.IsOriginal.peek()) {
                this.toggleOriginal(false);
                this.toggleRevision(true);
                this.toggleShiftClosure(true);
            }
            else if (this.IsShiftClosure.peek()) {
                this.toggleOriginal(true);
                this.toggleRevision(true);
                this.toggleShiftClosure(false);
            }
            else {
                this.toggleOriginal(true);
                this.toggleRevision(false);
                this.toggleShiftClosure(true);
            }
        }
        else {
            this.toggleOriginal(false);
            this.toggleRevision(false);
            this.toggleShiftClosure(false)
            BaoMenu.permissionEnable({ ActionKey: this.PermissionPrefix + 'Close', Enabled: this.IsValid.peek(), Context: this.TabPage.Context() });
        }
        if (this.IsReadByUser()) {
            BaoMenu.permissionEnable({ ActionKey: this.PermissionPrefix + 'MarkRead', Enabled: false, Context: this.TabPage.Context() });
            BaoMenu.permissionEnable({ ActionKey: this.PermissionPrefix + 'UnMarkRead', Enabled: true, Context: this.TabPage.Context() });
        } else {
            BaoMenu.permissionEnable({ ActionKey: this.PermissionPrefix + 'MarkRead', Enabled: true, Context: this.TabPage.Context() });
            BaoMenu.permissionEnable({ ActionKey: this.PermissionPrefix + 'UnMarkRead', Enabled: false, Context: this.TabPage.Context() });
        }
    }
    ;
    toggleOriginal(enable) {
        BaoMenu.permissionEnable({ ActionKey: this.PermissionPrefix + 'Original', Enabled: enable, Context: this.TabPage.Context() });

    }
    toggleRevision(enable) {
        BaoMenu.permissionEnable({ ActionKey: this.PermissionPrefix + 'Revision', Enabled: enable, Context: this.TabPage.Context() });

    }
    toggleShiftClosure(enable) {
        BaoMenu.permissionEnable({ ActionKey: this.PermissionPrefix + 'ShiftClosure', Enabled: enable, Context: this.TabPage.Context() });

    }
    //
    // Check ob Tabs aktualisiert werden können
    canRefresh() {
        var deferred = $.Deferred();
        var canCloseDeferreds = ko.utils.arrayMap(this.TabViewModel.Tabs(), (tab: any) => {
            if (ko.isObservable(tab.ViewModel) && tab.ViewModel()) {
                if ($.isFunction(tab.ViewModel().canClose)) {
                    return tab.ViewModel().canClose();
                }
            }
        });
        let __this = this;
        $.when.apply($, canCloseDeferreds).then((...myArguments) => {
            var result = myArguments;
            var canClose = ko.utils.arrayIndexOf(<any>result, false) === -1;
            if (canClose) {
                deferred.resolve(true);
            }
            else {
                __this.TabPage.IsLoading(false);
                var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.SaveCheck), 'question');
                dialog.DialogResult.subscribe((result) => {
                    if (result === true) {
                        var activeInfoTab = this.TabViewModel.SearchTabByObjectId('ActiveInfo');
                        if (activeInfoTab && activeInfoTab.IsDirty) {
                            this.validateDate().then(res => {
                                if (res.Value === true) {
                                    //Ja ==> Speichern
                                    __this.CompleteCheck().then((completeCheckResult) => {
                                        if (completeCheckResult) {
                                            __this.TabViewModel.SaveTabs(null).then(() => {
                                                deferred.resolve(true);
                                            });
                                        }
                                        else {
                                            deferred.resolve(false);
                                        }
                                    });
                                } else {
                                    new BaoDialog(Bao.Session.ApplicationName, res.Message, "info");
                                    deferred.resolve(false);
                                }
                            })
                        }
                    }
                    else if (result == false) {
                        //Nein
                        deferred.resolve(true);
                    }
                    else {
                        //Cancel
                        deferred.resolve(false);
                    }
                });
            }
        });
        return deferred.promise();
    }
    ;
    //
    // Zum nächsten Schichtbericht navigieren
    next() {
        this.TabPage.IsLoading(true);
        this.canRefresh().then((canRefresh) => {
            if (canRefresh) {
                Bao.post('ShiftReport/GetNextReportId', JSON.stringify({
                    id: this.ReportId()
                })).then((nextReportId) => {
                    if (nextReportId.MaxAllowed) {
                        Bao.Session.GetMessage("msgCanNotOpenReport").then((message) => {
                            let dialog = new BaoDialog(Bao.Session.ApplicationName, message.replace('{0}', moment.duration(nextReportId.MaxAllowed, "minutes").humanize()), 'info');
                            this.TabPage.IsLoading(false);
                        });
                        return;
                    }
                    if (nextReportId === "00000000-0000-0000-0000-000000000000") {
                        var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.ReportNextReportIdError), 'info');
                        this.TabPage.IsLoading(false);
                        return;
                    }
                    var tabFound = appTabController.SearchTabByObjectId(nextReportId);
                    if (tabFound) {
                        appTabController.SelectTab(tabFound);
                        this.TabPage.IsLoading(false);
                    }
                    else {
                        this.TabPage.ObjectId(nextReportId);
                        this.IsShiftClosure(false);
                        this.refresh(true);
                    }
                });
            }
            else {
                this.TabPage.IsLoading(false);
            }
        });
    }
    ;
    //
    // Zum vorherigen Schichtbericht navigieren
    previous() {
        this.TabPage.IsLoading(true);
        this.canRefresh().then((canRefresh) => {
            if (canRefresh) {
                Bao.post('ShiftReport/GetPreviousReportId', JSON.stringify({
                    id: this.ReportId()
                })).then((previousReportId) => {
                    var tabFound = appTabController.SearchTabByObjectId(previousReportId);
                    if (tabFound) {
                        appTabController.SelectTab(tabFound);
                        this.TabPage.IsLoading(false);
                    }
                    else {
                        this.IsShiftClosure(false);
                        this.TabPage.ObjectId(previousReportId);
                        this.refresh(true);
                    }
                });
            }
            else {
                this.TabPage.IsLoading(false);
            }
        })
    }

    // Schichtbericht aktualisieren
    refresh(ignoreCheck?) {
        var performRefresh = () => {
            this.getReport(true).then(() => {
                this.toggleButtons();
                this.TabPage.IsLoading(false);
            });
        };
        if (ignoreCheck) {
            this.TabPage.IsLoading(true);
            performRefresh();
        }
        else {
            this.canClose().then((canClose) => {
                if (canClose) {
                    performRefresh();
                }
                else {
                    this.TabPage.IsLoading(false);
                }
            });
        }
    }
    
    // Originalmodus
    original() {
        this.canClose().then((result) => {
            if (result) {
                this.IsShiftClosure(false);
                this.CurrentRevision(false);
                this.IsOriginal(true);

                this.toggleButtons();
            }
        })
    }
    
    // Revisionsmodus
    revision() {

        this.IsOriginal(false);
        this.IsShiftClosure(false);
        this.CurrentRevision(true);

        this.toggleButtons();
    }

    /**
     * Set the variable IsShiftClosure when user click on the button "Status of report closing"
     * */
    ShiftClosure() {

        this.IsOriginal(false);
        this.CurrentRevision(false);
        this.IsShiftClosure(true);

        this.toggleButtons();
    }
    //
    // Schichtbericht drucken
    print() {
        this.getInfoTabSorting().then((sorting) => {
            let sortingColumn;
            let sortingDirection;
            if (sorting != null && sorting.length > 0) {
                sortingColumn = sorting[0]?.Column;
                sortingDirection = sorting[0]?.Direction == "Ascending" ? 0 : 1;
            }

            let urlString = window.absolutePath + 'ShiftReport/Print/' + this.ReportId() + '?isOriginal=' + this.IsOriginal() + '&isShiftClosure=' + this.IsShiftClosure();
            if (sortingColumn != null && sortingDirection != null) {
                urlString += '&sortingColumn=' + sortingColumn + '&sortingDirection=' + sortingDirection;
            }
            window.open(urlString);
        });
    }

    /**
     * Pick the "main" info tab to use as the source of sorting for printing
     * @returns The info tab to use or null
     */
    pickMainInfoTab() {
        return Bao.get("ShiftReport/GetShiftEventTabIds").then((relevantTabTypes) => {
            const relevantTabs = this.TabViewModel.Tabs().filter(t => {
                const tabModel = this.TabModels().find(tm => tm.TabId() == t.ObjectId());
                if (!tabModel) return false;
                return relevantTabTypes.includes(tabModel.TabTypeId());

            })
            // 1. Try to pick the active tab first
            const activeTab = relevantTabs.find(t => t.IsActiveTab())
            if (activeTab) {
                return activeTab;
            }
            // 2. Pick any shift event tab with defined sorting
            const definedSortingTab = relevantTabs.find(tab => tab.ViewModel()?.Sorting?.() != null && tab.ViewModel()?.Sorting?.().length > 0);
            if (definedSortingTab) {
                return definedSortingTab;
            }
            // 3. Skip sorting
            return null;
        });
    }

    /**
     * Get sorting from the main info tab
     * @returns Sorting array or null
     */
    getInfoTabSorting() {
        return this.pickMainInfoTab().then((tab) => {
            if (tab != null) {
                return tab.ViewModel().Sorting();
            } else {
                return null;
            }
        });
    }

    /**
     * Get id of the main info tab
     * @returns Id or null
     */
    getInfoTabIdForSorting() {
        return this.pickMainInfoTab().then((tab) => {
            if (tab != null) {
                return tab.ObjectId()
            } else {
                return null;
            }
        });
    }

    /**
     * Get sortings of all tabs
     * @returns A dictionary where key = tabId, value = sorting array
     */
    getAllTabsSortings() {
        return this.TabViewModel.Tabs().reduce((dic, tab) => {
            let sorting = tab.ViewModel()?.Sorting?.();
            if (sorting != null) {
                sorting = sorting.map(s => ({ ...s, Direction: s.Direction === "Ascending" ? 0 : 1 }));
            }
            dic[tab.ObjectId()] = sorting;
            return dic;
        }, {});
    }
    close() {
        this.TabPage.IsLoading(true);
        //canClose speichert nicht! macht nur completeCheck
        this.canClose(true)
            .then((canClose) => {
                if (!canClose) {
                    return; //cancel/abort
                }
                this.TabPage.IsLoading(true);
                return Bao.post('ShiftReport/Close', JSON.stringify({
                    id: this.ReportId()
                })).then((serverResult) => {
                    this.TabPage.IsLoading(false);
                    if (serverResult.IsClosed) {
                        return this.raiseCloseReportOnTabs()
                            .then(() => {
                                return this.getReport();
                            }).then(() => {
                                this.toggleButtons();
                            });
                        //Ende 
                    }
                    else {
                        if (!serverResult.IsInCloseTimeWindow) {
                            var timeWindowErrorDialog = new BaoDialog(Bao.Session.ApplicationName, serverResult.ErrorMessage, "info");
                            timeWindowErrorDialog.Closed = () => {
                                this.afterFailedClose();
                            };
                        }
                        else {
                            this.afterFailedClose();
                        }
                    }
                });
            })
            .always(() => {
                this.TabPage.IsLoading(false);
            });
    }
    ;

    afterFailedClose() {
        this.toggleButtons();
        this.getReport().then(() => {
            this.TabPage.IsLoading(false);
        });
    }
    // Bericht als gelesen markieren
    markRead() {
        this.TabPage.IsLoading(true);
        Bao.post('ShiftReport/MarkRead', JSON.stringify({
            id: this.ReportId()
        })).then((serverResult) => {
            this.getReport().then(() => {
                this.toggleButtons();
            });
        }).always(() => {
            this.TabPage.IsLoading(false);
        });
    }

    /**
     * Method for read mark remove
     */
    unMarkRead() {
        this.TabPage.IsLoading(true);
        Bao.post('ShiftReport/UnMarkRead', JSON.stringify({
            id: this.ReportId()
        })).then((serverResult) => {
            this.getReport().then(() => {
                this.toggleButtons();
            });
        }).always(() => {
            this.TabPage.IsLoading(false);
        });
    }

    // Kalender öffnen, um Bericht nach Tag auszuwählen
    DialogWidth: number = 300;
    DateToJumpTo: KnockoutObservable<string> = ko.observable("");
    calendar() {
        this.TabPage.IsLoading(true);
        return Bao.post("ShiftReport/CalendarDialog", (result) => {
            let dialog = new BaoDialog(Bao.Session.ApplicationName);
            dialog.ViewModel(this);
            dialog.Template(result);
            let okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                this.JumpToDate();
                dialog.Close();
            });
            let cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            });
            if (this.DialogWidth != null) {
                dialog.Width(this.DialogWidth + "px");
            }
            dialog.Buttons([okButton, cancelButton]);
            dialog.Open();
            $('#shiftreportcalendardialogdatetimepicker').datetimepicker({
                inline: true,
                format: "yyyyMMdd",
                locale: ko.unwrap(Bao.Session.Language.Symbol),
                icons: {
                    previous: 'fal fa-chevron-left',
                    next: 'fal fa-chevron-right'
                }
            });
            // set DateToJumpTo to today (first thing it is set to in datetimepicker)
            this.DateToJumpTo(moment($('#shiftreportcalendardialogdatetimepicker').data["DateTimePicker"]).format(Bao.Utils.DateOnlyFormat));
            $('#shiftreportcalendardialogdatetimepicker').on('dp.change', (e) => {
                this.DateToJumpTo(moment(e["date"]).format(Bao.Utils.DateOnlyFormat));
            });
            this.TabPage.IsLoading(false);
        });
    }
    JumpToDate() {
        this.TabPage.IsLoading(true);
        this.canRefresh().then((canRefresh) => {
            if (canRefresh) {
                Bao.post('ShiftReport/GetReportIdByDate', JSON.stringify({
                    dateString: this.DateToJumpTo() + this.GetShiftStartTime(),
                    id: this.ReportId()
                })).then((nextReportId) => {
                    if (nextReportId.MaxAllowed) {
                        Bao.Session.GetMessage("msgCanNotOpenReport").then((message) => {
                            let dialog = new BaoDialog(Bao.Session.ApplicationName, message.replace('{0}', moment.duration(nextReportId.MaxAllowed, "minutes").humanize()), 'info');
                            this.TabPage.IsLoading(false);
                        });
                        return;
                    }
                    if (nextReportId === "00000000-0000-0000-0000-000000000000") {
                        var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.ReportGetByDateError), 'info');
                        this.TabPage.IsLoading(false);
                        return;
                    }
                    var tabFound = appTabController.SearchTabByObjectId(nextReportId);
                    if (tabFound) {
                        appTabController.SelectTab(tabFound);
                        this.TabPage.IsLoading(false);
                    }
                    else {
                        this.TabPage.ObjectId(nextReportId);
                        this.refresh(true);
                    }
                });
            }
            else {
                this.TabPage.IsLoading(false);
            }
        });
    }
    // gets hours, minutes and seconds of ShiftStartTime without colon (12:00:34 => 120034)    
    GetShiftStartTime() {
        if (this.ShiftStartTime() != "") {
            let stringArray = this.ShiftStartTime().split('T');
            if (stringArray != null && stringArray.length > 1) {
                let stringArray2 = stringArray[1].split(':');
                if (stringArray2 != null && stringArray2.length > 2) {
                    return stringArray2[0] + stringArray2[1] + stringArray2[2];
                }
            }
        }
        return "";
    }
    //
    // Schichtgruppe speichern
    saveShiftGroup(shiftGroupId) {
        setTimeout(() => {
            var reportId = this.ReportId();
            Bao.post('ShiftReport/SaveShiftGroup', JSON.stringify({
                id: reportId,
                shiftGroupId: shiftGroupId
            })).then((shiftGroupChanged) => {
                if (shiftGroupChanged) {
                    Bao.raiseEvent('shiftreport:shiftgroupchanged', { ReportId: reportId, ShiftGroupId: shiftGroupId });
                }
            });
        }, 1);
    }
    ;
    loadNewShiftreport(shiftbookId) {
        var tabPage = this.TabPage;
        var self = this;
        this.isQuickStartModuleActive();
        tabPage.IsLoading(true);
        return Bao.post('Report/GetReportIdByShiftbookAndCurrentDate', JSON.stringify({
            shiftbookId: shiftbookId,
            validDateJs: this.ValidDateJs()
        }))
            .then(function (reportId) {
                if (reportId != null) {
                    tabPage.ObjectId(reportId);
                    return self.getReport().then(() => {
                        self.toggleButtons();

                    });
                }
            })
            .always(function () {
                tabPage.IsLoading(false);
            });
    }
    ;
    raiseCloseReportOnTabs() {
        this.TabPage.IsLoading(true);
        // get tabs and if exists they result from their .CloseReport()
        let closeDefArray = this.TabViewModel.Tabs().filter(tab => tab.Loaded() == true && tab.ViewModel() != null && typeof tab.ViewModel().CloseReport == "function").map(tab => tab.ViewModel().CloseReport())

        return $.when(...closeDefArray)
            .then((...results) => {
                // check if any result failed/is false
                if (results.some(result => result === false)) {
                    new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgErrorOnClose"), "info");
                    return false;
                }
                return true;
            }).always(() => {
                this.TabPage.IsLoading(false);
            });
    }
    private SetPermissions(permissions) {
        if (!permissions)
            return;
        for (let actionKey in permissions) {
            BaoMenu.permissionVisible({ ActionKey: actionKey, Context: this.TabPage.Context(), Visible: permissions[actionKey] });
        }

        if (permissions["actionFormShiftReportShowRead"] == true) {
            this.HasShowReadersPermission(true);
        }
    }
    changeFavoriteStatus = () => {
        var promise;
        if (this.IsFavorite()) {
            promise = this.removeQuickStartModuleWebUrl();
        }
        else {
            promise = this.addQuickStartModule();
        }
        promise.then(() => { Bao.raiseEvent('QuickStartModules:refresh', null); });
    };
    addQuickStartModule = () => {
        this.TabPage.IsLoading(true);
        var selectedShiftbook = this.Shiftbooks().
            filter(e => e.ShiftbookId === this.ShiftbookId());
        var shiftbookName = selectedShiftbook[0].Name;
        var shiftbookIcon = selectedShiftbook[0].CssClass;
        return Bao.post("StartModule/AddQuickStartModule", JSON.stringify({
            caption1: shiftbookName,
            caption2: shiftbookName,
            caption3: shiftbookName,
            caption4: shiftbookName,
            caption5: shiftbookName,
            webUrl: this.GetShiftbookDeepLink(),
            color: this.Color,
            icon: (typeof shiftbookIcon != 'undefined' && shiftbookIcon) ? shiftbookIcon : this.Icon,
            sort: this.Sort
        })).done(result => {
            if (result) {
                this.IsFavorite(true);
            }
            this.TabPage.IsLoading(false);
        });
    };
    removeQuickStartModuleWebUrl = () => {
        this.TabPage.IsLoading(true);
        return Bao.post("StartModule/RemoveQuickStartModuleByWebUrl", JSON.stringify({
            webUrl: this.GetShiftbookDeepLink()
        })).done(result => {
            if (result) {
                this.IsFavorite(false);
            }
            this.TabPage.IsLoading(false);
        });
    };
    isQuickStartModuleActive = () => {
        return Bao.post("StartModule/IsQuickStartModuleActive", JSON.stringify({
            webUrl: this.GetShiftbookDeepLink()
        })).done(result => {
            this.IsFavorite(result);
        });
    };
    GetShiftbookDeepLink() {
        return "#/Report/ReportByShiftbookId/" + this.ShiftbookId();
    }

    validateDate = () => {
        return Bao.post('Information/ValidateDate', JSON.stringify({
            reportId: this.ReportId(),
        }))
    };

    /**
    * Expands and collapses the readers box
    */
    ShowAllReadersToggle = () => {
        this.ShowAllReadByEntries(!this.ShowAllReadByEntries());

        Bao.post("ShiftReport/SaveReadAllState", JSON.stringify({ showAllReadByEntries: this.ShowAllReadByEntries() }));
    }

    /**
    * returns the current state of the readers box according to the UserProfile
    */
    GetReadAllState = () => {
        Bao.post("ShiftReport/GetReadAllState").done(result => {
            this.ShowAllReadByEntries(result.ShowAllReadByEntries === "true" ? true : false);
        });
    }

    private openAdvancedPrintingDialog() {
        this.TabPage.IsLoading(true);
        return Bao.post("ShiftReport/AdvancedPrintingDialog")
            .done(result => {
                let dialog = new BaoDialog(Bao.Session.GetMessage("msgUniversalReportDialogTitle"), result.Template);
                dialog.Width("600px");
                dialog.ViewModel(new AdvancedPrintingDialog(this));
                let viewModel = <AdvancedPrintingDialog>dialog.ViewModel();
                dialog.Buttons([
                    new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("ReportViewerPrint"), () => {
                        return viewModel.setUniversalReportMetaData()
                            .then(_ => {
                                let UniversalReportLayoutId = viewModel.ReportLayoutIds();
                                let reportTabs = viewModel.ReportTabs().filter(tab => tab.IsSelected).map(tab => tab.TabName);
                                let isOriginal = this.IsClosed() ? viewModel.ExportVersion() === 'original' : false;

                                if (UniversalReportLayoutId === null || UniversalReportLayoutId.length === 0 || UniversalReportLayoutId[0] === null) {
                                    new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgNoLayoutSelected"), "info");
                                }
                                else if (reportTabs.length === 0) {
                                    new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgUniversalReportNoTabsSelected"), "info");
                                }
                                else {
                                    this.TabPage.IsLoading(true);
                                    return this.getInfoTabIdForSorting().then((tabId) => {
                                        return Bao.post("ShiftReport/AdvancedPrinting", JSON.stringify({
                                            id: this.ReportId(),
                                            isOriginal: isOriginal,
                                            isShiftClosure: this.IsShiftClosure(),
                                            relevantShiftInfo: viewModel.RelevantShiftInformations(),
                                            universalReportLayoutIds: UniversalReportLayoutId,
                                            selectedTabs: reportTabs,
                                            sortings: this.getAllTabsSortings(),
                                            infoTabIdForSorting: tabId
                                        }), function (result) {
                                            if (result.Result == true) {
                                                baoRouter.setHash("document/" + result.Message);
                                                dialog.Close();
                                            }
                                        }).always(_ => this.TabPage.IsLoading(false));
                                    });
                                }
                            });
                    }),
                    new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                        viewModel.setUniversalReportMetaData();
                        dialog.Close();
                    })
                ]);
                dialog.Open();
                this.TabPage.IsLoading(false);
            });
    }
}
export interface NotLoadedTabsUrls {
    TabId: string;
    CompleteCheckUrl: string;
}
//
export default ShiftReportViewModel;